import { api } from "@/api";
import { postGenerateMajorId } from "@/api/quotaion/designQuotationResultController/generateMajorId/post.js";
import Vue from "vue";
//通用模块状态控制
const commModule = {
  state: {
    deptTree: {
      data: [],
      tmpData: {
        OPPEIN: [],
        AGENT: [],
        OTHER: [],
      },
      curType: "OPPEIN",
      props: {
        label: "name",
        children: "children",
      },
      loading: false,
    },

    brandCategory: {
      list: [],
      tree: [],
      props: {
        label: "name",
        children: "children",
        disabled: "disabled",
        value: "code",
      },
      loading: false,
    },

    uCenter: {
      setParent: false,
      clearTreeId: false, //opTree选中状态
      openId: "", //tree选中的ID
      initTree: false, //重新点击当前节点的Tree
      initTreeFlag: false, //重新点击当前节点的Tree,并且刷新树组件
      initTableData: false, //重新刷新人员管理table
    },

    serverProject: {
      checkedList: [],
      checkedPeople: [],
    }, // 选中的服务项目
    tableData: {},
    majorId: '',
    requestId: '',
  },

  //激发事件改变state
  mutations: {
    setFileName(state, n) {
      state.fileName = n;
    },
    setOpenId(state, n = 0) {
      state.uCenter.openId = n;
      state.uCenter.initTreeFlag = !state.uCenter.initTreeFlag;
    },
    setParent(state, n) {
      //用户中心 调整上级
      state.uCenter[n] = !state.uCenter[n];
    },
    deptTreeLoadingChange(state, n) {
      state.deptTree.loading = n === undefined ? !state.deptTree.loading : !!n;
    },
    deptTreeDataChange(state, n) {
      state.deptTree.data = n.data || [];
      state.deptTree.tmpData[n.type] = n.data || [];
      state.deptTree.curType = n.type;
    },

    brandCategoryLoadingChange(state, n) {
      state.brandCategory.loading =
        n === undefined ? !state.brandCategory.loading : !!n;
    },
    brandCategoryDataChange(state, n) {
      let tmp = n || [];
      state.brandCategory.tree = tmp.map((v) => {
        v.children.forEach((x) => {
          delete x.children;
        });
        return v;
      });
      state.brandCategory.list = Array.prototype.concat.apply(
        [],
        tmp.map((v) =>
          v.children.map((x) => {
            return { brand: v.code, category: x.code };
          }),
        ),
      );
    },
    setCheckedServerProject(state, n) {
      state.serverProject.checkedList = n;
    },
    setChecked(state, n) {
      state.serverProject.checkedPeople = n;
    },
    //缓存页面数据
    keepTableData(state, n) {
      state.tableData = n;
    },
    SET_MAJOR_ID(state, n) {
      state.majorId = n;
    },
    SET_REQUEST_ID(state, n) {
      state.requestId = n;
    },
  },

  // 异步操作拿远程数据,然后提交事件
  actions: {
    loadDeptTree({ commit, state }, condition) {
      //执行查询
      let type = condition ? condition.type || "OPPEIN" : "OPPEIN";
      let parentId = condition ? condition.parentId || "Root" : "Root";
      commit("deptTreeDataChange", { data: [], type: type });
      commit("deptTreeLoadingChange", true);
      console.log(1);
      api.department
        .tree({
          parentId: parentId,
          orgType: type,
        })
        .then((res) => {
          console.log(2);
          commit("deptTreeLoadingChange", false);
          commit("deptTreeDataChange", { data: res.data, type: type });
        });
    },
    loadBrandCategory({ commit, state }) {
      //执行查询
      if (
        state.brandCategory.tree.length === 0 &&
        state.brandCategory.loading === false
      ) {
        commit("brandCategoryLoadingChange", true);
        api.system.brandTree().then((res) => {
          commit("brandCategoryLoadingChange", false);
          commit("brandCategoryDataChange", res.data);
        });
      }
    },
    checkServerProject({ commit }, payload) {
      commit("setCheckedServerProject", payload);
    },
    setCheckedPeople({ commit }, payload) {
      commit("setChecked", payload);
    },
    postGenerateMajorIdAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        postGenerateMajorId().then((res) => {
          console.log("获取postGenerateMajorIdAction----",res);
          commit("SET_MAJOR_ID", res);
          resolve(res);
        });
      });
    },
    postGenerateRequestIdAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        postGenerateMajorId().then((res) => {
          console.log("获取postGenerateRequestIdAction----",res);
          commit("SET_REQUEST_ID", res);
          resolve(res);
        });
      });
    },
  },

  //频繁通用计算
  getters: {},
};

export default commModule;



// WEBPACK FOOTER //
// ./src/store/modules/common.js